import { useEffect, useRef } from "react";

import { analyticsService } from "../../../lib/analytics";
import type { EventTypes } from "../../../lib/analytics/types";

type HomeScreenViewedArgs = EventTypes["HomeScreenViewed"] & {
  /** Blocks the event until the screen's data has resolved. */
  loading: boolean;
};

// Fires HomeScreenViewed exactly once per mount, the first time the screen
// finishes loading. Shared by both home arms so the two variants can never
// drift in event shape.
export function useHomeScreenViewedEvent({
  loading,
  variant,
  casesShownCount,
  actionableCasesCount,
  hasClosedWin,
}: HomeScreenViewedArgs): void {
  const fired = useRef(false);

  useEffect(() => {
    if (loading || fired.current) {
      return;
    }
    fired.current = true;
    analyticsService.trackEvent("HomeScreenViewed", {
      variant,
      casesShownCount,
      actionableCasesCount,
      hasClosedWin,
    });
  }, [loading, variant, casesShownCount, actionableCasesCount, hasClosedWin]);
}
